import { http } from "./http";

export interface TermsStatus {
  version: string;
  /** Conditions à accepter avant d’utiliser le service. */
  required: boolean;
  cguAccepted: boolean;
  dpaAccepted: boolean;
  /** Ce compte (gérant) accepte l’accord de traitement au nom de l’auto-école. */
  dpaRequired: boolean;
}
export const legalTermsApi = {
  status: async () => (await http.get<TermsStatus>("/v1/legal-terms/status")).data,
  accept: async (input: { version: string; cgu: boolean; dpa: boolean }) =>
    (await http.post<TermsStatus>("/v1/legal-terms/accept", input)).data,
};
